import { render, staticRenderFns } from "./appUserProfile.vue?vue&type=template&id=db8e9532&scoped=true"
import script from "./appUserProfile.vue?vue&type=script&lang=js"
export * from "./appUserProfile.vue?vue&type=script&lang=js"
import style0 from "./appUserProfile.vue?vue&type=style&index=0&id=db8e9532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8e9532",
  null
  
)

export default component.exports